import { Input } from 'antd';
import React from 'react';
import './TextInputStyle.css';

const SsnLastFourInput = props => {
    const { def, data, onChange, state, warning } = props;
    const err = warning !== undefined && warning !== '' ? "error" : "";

    const checkNumeric = (value) => {
        if (isNaN(value) && value !== '') return;

        const lenWarning = `"${def.label}" must be 4 digits`;

        const newWarning = value.length > 0
            ? value.length < 4 ? lenWarning : ''
            : state.required ? lenWarning : '';

        onChange(def.dataKey, value, newWarning);
    }

    return <Input
        id={def.dataKey}
        data-input={'ssn4input_de'}
        className={'basicinput_de'}
        status={err}
        readOnly={state.readonly}
        disabled={state.readonly}
        value={data}
        onChange={ev => checkNumeric(ev.target.value)}
        placeholder="####"
        maxLength={4}
        onKeyDown={(evt) => evt.key === '.' && evt.preventDefault()}
    />
}

export default SsnLastFourInput;
